module.exports = __webpack_public_path__ + "img/T6-A-xh_08.7b9fe3cd.png";